(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents) {
    const fmt = window.theme.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_with_comma_separator': return withDots + ',' + dec;
        case 'amount_no_decimals_with_comma_separator': return withDots;
        case 'amount_no_decimals': return withCommas;
        default: return withCommas + '.' + dec;
      }
    });
  }

  let toastTimer;
  function toast(msg) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2500);
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    const nav = $('#HeaderNav');
    const open = nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open);
  });

  /* ---------- Gallery ---------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    const main = $('[data-gallery-main]', gallery);
    const src = thumb.dataset.full;
    const img = $('img', main);
    if (img && src) {
      img.src = src;
      img.removeAttribute('srcset');
      img.alt = thumb.dataset.alt || '';
    }
    $$('[data-thumb]', gallery).forEach((b) => b.classList.toggle('is-active', b === thumb));
  });

  /* ---------- Pack / variant selection ---------- */
  function syncProductForm(form) {
    const checked = $('input[type="radio"][name="quantity"]:checked, input[type="radio"][name="id"]:checked', form);
    const select = $('select[data-variant-select]', form);
    let price, available = true, variantId;
    if (checked) {
      variantId = checked.name === 'id' ? checked.value : null;
      price = +checked.dataset.price;
      available = checked.dataset.available === 'true';
    } else if (select) {
      const opt = select.options[select.selectedIndex];
      variantId = opt.value;
      price = +opt.dataset.price;
      available = opt.dataset.available === 'true';
    }
    const total = $('[data-total]', form.closest('[data-product]'));
    if (total && !isNaN(price)) total.textContent = formatMoney(price);
    const btn = $('[data-add-button]', form);
    if (btn) {
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
    }
    if (variantId && history.replaceState) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url);
    }
  }
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (form && (e.target.name === 'id' || e.target.name === 'quantity' || e.target.matches('[data-variant-select]'))) syncProductForm(form);
  });
  $$('[data-product-form]').forEach(syncProductForm);

  /* ---------- Cart drawer ---------- */
  const drawerSection = 'cart-drawer';
  function drawer() { return $('#CartDrawer'); }

  function openDrawer() {
    const d = drawer();
    if (!d) { location.href = window.theme.routes.cart_url; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const close = $('[data-drawer-close]', d);
    close && close.focus();
  }
  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderSections(sections) {
    if (!sections || !sections[drawerSection]) return;
    const html = new DOMParser().parseFromString(sections[drawerSection], 'text/html');
    const fresh = $('#CartDrawerInner', html);
    const current = $('#CartDrawerInner');
    if (fresh && current) current.replaceWith(fresh);
    const count = $('[data-cart-count-value]', html);
    if (count) $$('[data-cart-count]').forEach((el) => { el.textContent = count.dataset.cartCountValue; });
  }

  async function cartRequest(url, body) {
    const d = drawer();
    d && d.classList.add('is-loading');
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: [drawerSection], sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || window.theme.strings.error);
      renderSections(data.sections);
      return data;
    } finally {
      d && d.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !drawer()) return;
    e.preventDefault();
    const btn = $('[data-add-button]', form);
    btn && (btn.disabled = true);
    try {
      const fd = new FormData(form);
      await cartRequest(window.theme.routes.cart_add_url + '.js', {
        items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }]
      });
      openDrawer();
    } catch (err) {
      toast(err.message);
    } finally {
      btn && (btn.disabled = false);
    }
  });

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      try {
        await cartRequest(window.theme.routes.cart_change_url + '.js', {
          id: qtyBtn.dataset.key, quantity: +qtyBtn.dataset.qtyChange
        });
      } catch (err) { toast(err.message); }
      return;
    }
    const upsell = e.target.closest('[data-upsell]');
    if (upsell) {
      try {
        if (upsell.dataset.key) {
          await cartRequest(window.theme.routes.cart_change_url + '.js', { id: upsell.dataset.key, quantity: 0 });
        } else {
          await cartRequest(window.theme.routes.cart_add_url + '.js', {
            items: [{ id: +upsell.dataset.variant, quantity: 1 }]
          });
        }
      } catch (err) { toast(err.message); }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Reviews "ver más" ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-reviews-toggle]');
    if (!btn) return;
    const wrap = btn.closest('[data-reviews]');
    const open = wrap.classList.toggle('is-expanded');
    $$('[data-review-extra]', wrap).forEach((r) => r.classList.toggle('is-hidden', !open));
    btn.textContent = open ? btn.dataset.less : btn.dataset.more;
  });
})();
